
import { locale } from './globals.js';
import { pageVisibilityStatus as pvs } from './toolbox.js';

const arrowBtn = function (dir) {
  return `<button class="arrow ${dir} custom">
    <i class="fal fa-chevron-circle-${locale[dir]} icon"></i>
  </button>`
}
let popupListenerOn = false;
let carouselShowing = new Event('carousel-showing');
let carouselHiding = new Event('carousel-hiding');
function popupListener() {
  if(popupListenerOn) return;
  popupListenerOn = true;
  $(document).on('beforeShow.fb', (instance, slide) => {
    requestAnimationFrame(() => {
      Array.from(slide.$refs.container[0].querySelectorAll('[data-image-carousel]')).forEach((carousel) => {
        carousel.dispatchEvent(carouselShowing);
      })
    });
  })
  $(document).on('afterClose.fb', (instance, slide) => {
    requestAnimationFrame(() => {
      Array.from(slide.$refs.container[0].querySelectorAll('[data-image-carousel]')).forEach((carousel) => {
        carousel.dispatchEvent(carouselHiding);
      })
    });
  })
}
class ImageCarousel {
  constructor(el) {
    if(!el) return false;
    if (el.hasAttribute('data-inited')) return;
    this.el = el;
    this.el.setAttribute('data-inited', true);
    this.rtl = (locale.dir == 'rtl');
    this.onScreen = true;
    if(this.el.children.length > 1) {
      this.initSlider();
    }
    
    if(this.el.closest('.popup-buffer')) {
      popupListener();
      this.onScreen = false;
      clearTimeout(this.scrollTimeout);
      this.el.addEventListener('carousel-showing', () => {
        this.onScreen = true;
        if(this.flkty) {
          this.flkty.resize();
          this.setScrollTimeout();
        }
      })
      this.el.addEventListener('carousel-hiding', () => {
        this.onScreen = false;
        if(this.flkty) {
          clearTimeout(this.scrollTimeout);
        }
      })
    }
  }
  initSlider () {
    
    Array.from(this.el.children).forEach((item) => {
      item.classList.add('image-carousel-item');
    })
    
    this.flkty = new Flickity(this.el, {
      contain: true,
      prevNextButtons: false,
      pageDots: false,
      rightToLeft: this.rtl,
      wrapAround: true
    });
    this.el.classList.add('image-carousel');
    this.pager = document.createElement('div');
    this.pager.classList.add('image-carousel-pager', 'pager-arrows');
    this.pager.innerHTML = arrowBtn('prev') + arrowBtn('next');
    this.el.insertBefore(this.pager, this.el.firstChild);
    this.tabParent = this.el.closest('[data-tab-content]');
    if(this.tabParent) {
      this.tabParent.addEventListener('tab-content-update', () => {
        if(this.tabParent.classList.contains('active')) {
          this.setScrollTimeout();
        } else {
          clearTimeout(this.scrollTimeout);
        }
      });
    }
    document.addEventListener(pvs().visibilityChange, () => {
      if(document[pvs().hidden]) {
        clearTimeout(this.scrollTimeout)
      } else {
        this.setScrollTimeout();
      }
    }, false);
    requestAnimationFrame(() => {
      this.initPagerControls();
    });
    this.flkty.on('change', this.setScrollTimeout.bind(this));
    this.setScrollTimeout();
    setTimeout(this.videoChild.bind(this), 500);
  }
  setScrollTimeout() {
    if(document[pvs().hidden] || !this.onScreen) return;
    if(!this.tabParent || this.tabParent.classList.contains('active')) {
      clearTimeout(this.scrollTimeout);
      this.scrollTimeout = setTimeout(() => {
        this.flkty.next(true);
      }, 7000);
    }
  }
  initPagerControls() {
    this.pager.querySelector('.arrow.prev').addEventListener('click', () => {
      this.flkty.previous(true);
    })
    this.pager.querySelector('.arrow.next').addEventListener('click', () => {
      this.flkty.next(true);
    })
  }
  videoChild() {
    this.flkty.cells.forEach((cell) => {
      let video = cell.element.querySelector('video');
      if(video) {
        video.addEventListener('play', () => {
          clearTimeout(this.scrollTimeout);
        })
        video.addEventListener('pause', () => {
          this.setScrollTimeout();
        })
      }
    });
  }
}

export function initAll () {
	Array.from(document.querySelectorAll('[data-image-carousel]')).forEach((elem, index) => {
		init(elem);
	});	
};

export function init(elem) {
  new ImageCarousel(elem);
}

export default function (elem) {
	if (!elem || elem.length < 1) {
		initAll();
	} else {
	  init(elem);
	}
}